// @flow
// For plural: {cancels} {cancels, plural, one {Cancel} other {Cancels}}
export default {
  'en-US': {
    titles: {
      contacts: 'Contacts',
      personalInfo: 'Personal Info',
    },
    labels: {
      name: '{n, plural, one {Name} other {Names}}',
      lastName: '{n, plural, one {Last Name} other {Last Names}}',
      phone: 'Phone',
      code: 'Code',
      email: 'Email',
      address: 'Address',
      assignedRoutes: 'Assigned Routes',
      monitor: 'Monitor',
      driver: 'Driver',
      type: 'Type',
      stops: 'Stops',
      route: '{n, plural, one {Route} other {Routes}}',
      allowsChangeRequests: 'Allows Change Requests',
      allowsEntry: 'Allows Entry',
      allowsExit: 'Allows Exit',
      students: '{n, plural, one {Student} other {Students}}',
      plates: 'Plates',
      capacity: 'Capacity',
      year: 'Year',
      identifier: 'Identifier',
    },
    buttons: {
      cancel: 'Cancel',
      delete: 'Delete',
      create: 'Create {Item}',
      requestChange: 'Request Stop Change',
      pending: 'Pending',
      solved: 'Solved',
      aprove: 'Aprove',
      reject: 'Reject',
      send: 'Send',
    },
    common: {
      settings: 'Settings',
      liveMap: 'Live map',
      changeStopRequest: 'Change Stop Requests',
      user: '{n, plural, one {User} other {Users}}',
      routesAndStops: 'Routes and Stops',
      bus: '{n, plural, one {Bus} other {Buses}}',
      gateway: '{n, plural, one {Gateway} other {Gateways}}',
      gate: '{n, plural, one {Gate} other {Gates}}',
      reports: 'Reports',
      passengers: '{n} {n, plural, one {passenger} other {passengers}}',
      search: 'Search...',
      booleanTrue: 'Yes',
      booleanFalse: 'No',
      loading: 'Loading {Item}...',
      noResults: "There doesn't appear to be {Item}",
      confirmDeletion: 'Are you sure you want to delete {Item}?',
    },
    changeStopRequests: {
      changeFor: 'Change Stop Request for ',
      fromTo: 'From {stop} to {stop2}',
      requestDate: 'Requested for dates ranging from {date} to {date2} by {user}',
      requestType: 'Request Type',
      dateRange: 'Range of Dates to apply change',
      toStop: 'Change to',
      commentary: 'Commentary',
      commented: "{user}'s commentary:",
      reason: 'Reason',
    },
    routes: {
      expectedDepartureTime: 'Expected Departure Time',
      expectedArrivalTime: 'Expected Arrival Time',
      routeTimeFrame: 'Days the route is active',
    },
  },
  'es-MX': {
    titles: {
      contacts: 'Contactos',
      personalInfo: 'Información Personal',
    },
    labels: {
      name: '{n, plural, one {Nombre} other {Nombres}}',
      lastName: '{n, plural, one {Apellido} other {Apellidos}}',
      phone: 'Teléfono',
      code: 'Código',
      email: 'Correo',
      address: 'Dirección',
      assignedRoutes: 'Rutas Asignadas',
      monitor: 'Monitor',
      driver: 'Chofer',
      type: 'Tipo',
      stops: 'Paradas',
      route: '{n, plural, one {Ruta} other {Rutas}}',
      allowsChangeRequests: 'Permite Cambios',
      allowsEntry: 'Permite Entrada',
      allowsExit: 'Permite Salida',
      students: '{n, plural, one {Estudiante} other {Estudiantes}}',
      plates: 'Placas',
      capacity: 'Capacidad',
      year: 'Año',
      identifier: 'Identificador',
    },
    buttons: {
      cancel: 'Cancelar',
      delete: 'Borrar',
      create: 'Crear {Item}',
      requestChange: 'Solicitar Cambio de Parada',
      pending: 'Pendiente',
      solved: 'Resueltos',
      aprove: 'Aprobar',
      reject: 'Rechazar',
      send: 'Enviar',
    },
    common: {
      liveMap: 'Mapa en vivo',
      settings: 'Configuración',
      changeStopRequest: 'Solicitudes de Cambio',
      user: '{n, plural, one {Usuario} other {Usuarios}}',
      routesAndStops: 'Rutas y Paradas',
      bus: '{n, plural, one {Bus} other {Buses}}',
      gateway: '{n, plural, one {Medio de Salida} other {Medios de Salida}}',
      gate: '{n, plural, one {Puerta} other {Puertas}}',
      reports: 'Reportes',
      passengers: '{n} {n, plural, one {pasajero} other {pasajeros}}',
      search: 'Buscar...',
      booleanTrue: 'Si',
      booleanFalse: 'No',
      loading: 'Cargando {Item}...',
      noResults: 'No parece haber {Item}',
      confirmDeletion: '¿Esta seguro de querer borrar a {Item}?',
    },
    changeStopRequests: {
      changeFor: 'Cambio de ruta para ',
      fromTo: 'De {stop} a {stop2}',
      requestDate: 'Solicitado para fechas desde {date} hasta {date2} by {user}',
      requestType: 'Tipo de Cambio',
      dateRange: 'Dias para los que el cambio tomara efecto',
      toStop: 'Cambio hacia',
      commentary: 'Comentario',
      commented: '{user} comentó lo siguiente:',
      reason: 'Razón',
    },
    routes: {
      expectedDepartureTime: 'Hora de inicio',
      expectedArrivalTime: 'Hora de finalización',
      routeTimeFrame: 'Dias que sucedera la ruta',
    },
  },
};



// WEBPACK FOOTER //
// ./src/scripts/utils/messages.js